import React, { useEffect, useState } from "react";
import Main from "../layouts/Main";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { useDispatch } from "react-redux";
import { apis as api } from "../../services/api.action";
import ContentTop from "../ui-setup/ContentTop";
import { cnt } from "../../services/constant.action";
import { BOM, RAL } from "../../services/defined.action";
import appLabel from "../../config/appLabel";
import appStatic from "../../config/appStaticData";
import {
  TableFacility,
  tableData,
  HandleSkeletonTbleFac,
} from "../layouts/Facility";

const PoCleanList = (props) => {
  const { userData, menuData, location } = props;
  const { profileId, session, companyId } = userData;
  const globalVar = window.globalData;
  const { tableData } = appStatic;

  const dispatch = useDispatch();
  const [poData, setPoData] = useState([]);
  const [titleLeft, setTitleLeft] = useState("");
  const [titleRight, setTitleRight] = useState("");
  const [color, setColor] = useState("");
  const [icon, setIcon] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [tiles, setTiles] = useState([
    {
      title: appLabel.authorized,
      otherTitle: appLabel.authorizedListing,
      color: "primary",
      icon: "tag",
      criteria: "A",
      callback: function (params) {
        getListByCriteria(params);
      },
    },
    {
      title: appLabel.unauthorized,
      otherTitle: appLabel.unauthorizedListing,
      color: "warning",
      icon: "exclamation-triangle",
      criteria: "U",
      callback: function (params) {
        getListByCriteria(params);
      },
    },
    {
      title: appLabel.disabled,
      otherTitle: appLabel.disabledListing,
      color: "danger",
      icon: "close",
      criteria: "R",
      callback: function (params) {
        getListByCriteria(params);
      },
    },
  ]);

  useEffect(() => {
    // console.log(props);
    getListByCriteria(); // get position 0 object
  }, []);

  function getListByCriteria() {
    // BOM.LoadAlert(cnt.LOAD, "Processing");
    setIsLoading(true);

    let body = {
      profileId,
      orderId: "",
      criteria: "A",
      companyId,
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, api.GetPo, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        const objList = res.purchaseOrderListing;
        // const poInvoilessData = objList.filter(
        //   (item) => item.PO_INVOICE_CODE === ""
        // );
        setPoData(objList);

        BOM.DatatableUsage();
        setIsLoading(false);
      }
    });
  }

  const onSelectPo = (item) => {
    /** CHECK FOR RIGHT BTN PRIVILEGES */
    if (RAL.viewAction(menuData, "manage invoice")) {
      dispatch({
        type: cnt.RIGHT_DETAIL_BTN,
      });
    }

    globalVar.viewLink = {
      path: "/new-invoice",
      obj: { poId: item.ORDERID },
    };
  };

  /** RENDER JXS DATA */
  return (
    <Main {...props}>
      <ContentTop pageTitle={appLabel.activePo} />
      <div className="animated fadeInRightFAKE">
        <div className="row">
          <form className="m-t" autoComplete="off">
            <div className="col-lg-12">
              <div className="ibox float-e-margins">
                <div className="ibox-title">
                  <h5></h5>
                  <div className="ibox-tools">
                    <Link
                      to="/manage-invoice"
                      className="btn btn-primary btn-xs"
                    >
                      <i className="fa fa-arrow-circle-left" />
                      &nbsp;
                      {appLabel.backBtn}
                    </Link>
                  </div>
                </div>

                <div className="ibox-content panel-primary contentCard">
                  <HandleSkeletonTbleFac
                    classParam={`${isLoading ? "" : "hide"}`}
                  />
                  <div className={` ${isLoading ? "hide" : ""}`}>
                    {poData.length === 0 ? (
                      <div className="alert alert-warning text-center">
                        <a className="alert-link">
                          {appLabel.noDataInTableMsg}
                        </a>
                      </div>
                    ) : (
                      <TableFacility thData={tableData.poCleanList}>
                        {poData.map((item, index) => (
                          <tr className="gradeX" key={index}>
                            <td>
                              <label className="myradio-button">
                                <input
                                  type="radio"
                                  name="radio"
                                  onClick={() => onSelectPo(item)}
                                />
                                <span className="label-visible">
                                  <span className="myfake-radiobutton"></span>
                                </span>
                              </label>
                            </td>

                            <td>{item.PO_ORDER_DATE}</td>
                            <td>{item.ORDERID}</td>
                            <td>{item.BUYER}</td>
                            <td>{item.SUPPLIER}</td>
                          </tr>
                        ))}
                      </TableFacility>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </Main>
  );
};

const mapStateToProps = (state) => ({
  userData: state.auth.userData,
  menuData: state.staticData.menuData,
});

const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(PoCleanList);
